import React, { useEffect, useState } from "react";
import "./TopBar.css";

/**
 * Props
 * - message: string (required)
 * - bgColor: fallback background color (string) — overridden by animated gradient
 * - textColor: text color
 * - ctaText: optional CTA text
 * - onCta: optional callback for CTA
 * - autoHide: seconds (number) to auto-hide topbar (0 = never)
 * - closable: show close button
 */
const TopBar = ({
  message,
  bgColor = "#ffd700",
  textColor = "#fff",
  ctaText = "مشاهده",
  onCta = null,
  autoHide = 0,
  closable = true,
}) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    if (!autoHide || autoHide <= 0) return;
    const t = setTimeout(() => setVisible(false), autoHide * 1000);
    return () => clearTimeout(t);
  }, [autoHide]);

  if (!visible) return null;

  // set CSS variables so we get good contrast + control from props
  const styleVars = {
    "--topbar-bg": bgColor,
    "--topbar-text": textColor,
  };

  return (
    <div className="top-bar" style={styleVars} role="region" aria-label="site announcement">
      <div className="top-bar-inner">

        {/* marquee-ish / centered message */}
        <div className="top-bar-message-wrap">
          <span className="top-bar-message">{message}</span>
        </div>

        {/* CTA + close */}
        <div className="top-bar-actions">
          {onCta && (
            <button
              className="topbar-cta"
              onClick={onCta}
              aria-label={ctaText}
              type="button"
            >
              <span className="cta-text">{ctaText}</span>
              <span className="cta-pulse" aria-hidden />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default TopBar;
